function AssociationsMgmt() {
    return ('AssociationsMgmt');
}

export default AssociationsMgmt;
